import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import './SurveyModal.css'

import { setSurveyModalState } from '../../store/reducers/SessionReducer'

function SurveyModal() {
  const dispatch = useDispatch()

  const surveyModalOpened = useSelector(state => state.session.surveyModalOpened);

  const handleClose = () => {
    dispatch(setSurveyModalState(false))
    window.location.pathname = '/p'
  }

  if (!surveyModalOpened) {
    return null;
  }

  return (
    <div className='surv-wrapper'>
      <div className='surv-container'>
        <div
          className='sd-close'
          onClick={handleClose}
        />
        <iframe
          title='vrt-survey'
          className='surv-iframe'
          src={'https://www.onsitebefragung.de/uc/swr/5212/'}
          scrolling="auto"
        />
      </div>
    </div>
  )
};

export default SurveyModal;
